import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { of, Subject } from "rxjs";
import { delay } from "rxjs/operators";
var DataSubject = /*#__PURE__*/function () {
  function DataSubject() {
    _classCallCheck(this, DataSubject);
  }
  _createClass(DataSubject, null, [{
    key: "next",
    value: function next(type, data) {
      DataSubject.subject.next({
        type: type,
        data: data
      });
    }
  }, {
    key: "asyncNext",
    value: function asyncNext(type, data) {
      of(0).pipe(delay(100)).subscribe(function () {
        return DataSubject.subject.next({
          type: type,
          data: data
        });
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(listener) {
      return DataSubject.subject.subscribe(function (next) {
        var action = next;
        listener(action.type, action.data);
      });
    }
  }]);
  return DataSubject;
}();
_defineProperty(DataSubject, "TYPE_ACCOUNT_SIGN_IN", "type_account_sign_in");
_defineProperty(DataSubject, "TYPE_COLLECT_LIST_CHANGED", "type_collect_list_changed");
_defineProperty(DataSubject, "TYPE_SET_SIGN_PAGE", "type_set_sign_page");
_defineProperty(DataSubject, "TYPE_LOCALE_CHANGED", "type_locale_changed");
_defineProperty(DataSubject, "TYPE_ZENDESK_WIDGET_READY", "type_zendesk_widget_ready");
_defineProperty(DataSubject, "TYPE_RE_CAPTCHA_READY", "type_re_captcha_ready");
_defineProperty(DataSubject, "subject", new Subject());
export { DataSubject as default };